import { Box, Button, TextField, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { signupSubscriptionTokenStyles } from './SignupSubscriptionToken.styles';

interface SignupSubscriptionTokenProps {
  token: string;
  isWorking: boolean;
  isProductView?: boolean;
  showTokenReplacement?: boolean;
  confirmedSubscription?: {
    productLabel?: string;
    schoolName?: string;
    planName?: string;
  };
  onTokenChange: (token: string) => void;
  onUseToken: (token: string) => void;
  onReset: () => void;
}

export function SignupSubscriptionToken({token, isWorking, isProductView = false, showTokenReplacement = false, confirmedSubscription, onTokenChange, onUseToken, onReset}: SignupSubscriptionTokenProps) {
  const theme = useTheme();

  const tokenControls = confirmedSubscription ? (
    <Box role="status" sx={signupSubscriptionTokenStyles.tokenConfirmation(theme)}>
      {isProductView ? (
        <Typography><strong>{confirmedSubscription.productLabel}</strong> subscription confirmed.</Typography>
      ) : (
        <>
          <Typography>Subscription confirmed for <strong>{confirmedSubscription.schoolName}</strong>.</Typography>
          {confirmedSubscription.planName && <Typography>{confirmedSubscription.planName}</Typography>}
        </>
      )}
      {showTokenReplacement && <Button type="button" variant="text" disabled={isWorking} onClick={onReset} sx={signupSubscriptionTokenStyles.resetButton(theme)}>Use a different token</Button>}
    </Box>
  ) : (
    <Box id="subscription-token-panel" sx={signupSubscriptionTokenStyles.tokenPanel(isProductView)}>
      <TextField label="Subscription token" placeholder="Enter your subscription token" value={token} disabled={isWorking} onChange={(event) => onTokenChange(event.target.value)} slotProps={{inputLabel: {shrink: true}}} sx={signupSubscriptionTokenStyles.input(theme)} />
      <Button type="button" variant="contained" disableElevation disabled={!token.trim() || isWorking} onClick={() => onUseToken(token.trim())} sx={signupSubscriptionTokenStyles.useTokenButton(theme)}>Use token</Button>
    </Box>
  );

  if (isProductView) {
    return (
      <Box component="section" aria-labelledby="subscription-heading" sx={signupSubscriptionTokenStyles.productSection()}>
        <Typography id="subscription-heading" component="h2" sx={signupSubscriptionTokenStyles.accountHeading()}>Subscription</Typography>
        {tokenControls}
      </Box>
    );
  }

  return tokenControls;
}
